__turbopack_context__.v({
  "backButton": "IFrameHeader-module__MRg0IG__backButton",
  "column": "IFrameHeader-module__MRg0IG__column",
  "headingContainer": "IFrameHeader-module__MRg0IG__headingContainer",
  "headline": "IFrameHeader-module__MRg0IG__headline",
  "iFrameHeader": "IFrameHeader-module__MRg0IG__iFrameHeader",
  "iFrameHeaderInnerContainer": "IFrameHeader-module__MRg0IG__iFrameHeaderInnerContainer",
});
